export default {
  bookExperiencePanel: '预订体验面板',
  calendarIcon: '日历图标',
  coverImageForResource: '{{title}}体验的封面图片',
  filterBy: '按{{filter}}筛选',
  filterByDateRange: '按日期范围筛选',
  gallery: '图库',
  goBack: '返回上一页',
  hostUserIcon: '主办方用户图标',
  imageOf: '{{title}}的图片',
  interactiveMapAltText: '可选择{{title}}的交互式地图',
  mediaSlides: '媒体幻灯片',
  muteVideo: '静音视频',
  nextPhoto: '下一张照片',
  noVideoPlayback: '无视频播放功能',
  pauseVideo: '暂停视频',
  photoOf: '{{name}}的照片',
  playVideo: '播放视频',
  previousPhoto: '上一张照片',
  reserveSelectedSlot: '预订所选时段',
  selectDate: '选择日期',
  selectParticipants: '选择参与者',
  selectSessionTime: '选择课程时间',
  unmuteVideo: '取消静音视频',
  viewShoppingCart: '查看购物车',
  zoomIn: '放大',
  zoomOut: '缩小',
  selectData: '选择{{data}}',
  reserveName: '预订{{name}}',
  deleteReservation: '删除{{experienceTitle}}预订',
  editParticipantsFor: '编辑{{experienceTitle}}的参与者',
  enterPromoCode: '输入优惠码',
  applyPromoCode: '应用优惠码',
  increaseAddOnAmount: '增加{{addOn}}选择',
  decreaseAddOnAmount: '减少{{addOn}}选择',
  addOnModal: '{{addOn}}模态框',
  moreInformationAboutAddOn: '关于{{addOn}}的更多信息',
  decreasePriceTierTickets: '减少{{priceTier}}票数',
  increasePriceTierTickets: '增加{{priceTier}}票数',
  downloadFilename: '下载{{filename}}',
  viewFullDetailsDescription: '查看完整详情描述',
  viewFullDescription: '查看完整描述',
  closeModal: '关闭模态框',
};
